import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/login-register/login-register.scss';
import Grid from '@material-ui/core/Grid';

import 'react-sticky-header/styles.css';
import StickyHeader from 'react-sticky-header';
import logo from 'Images/logo_v2.svg';
import logoSmall from 'Images/logo_v1.svg';

class Header extends React.Component {
  state = {
    sticked: false,
  };

  changeSticked = isSticky => {
    this.setState({ sticked: isSticky });
  };

  render() {
    return (
      <StickyHeader
        // This is the sticky part of the header.
        onSticky={sticky => {
          this.changeSticked(sticky);
        }}
        header={
          <Grid
            container
            alignItems={'center'}
            justify={'center'}
            className="header-wrapper"
          >
            <Grid item xs={11} className="header-root">
              <div className="header__logo">
                <Link className="" to="/">
                  <img
                    className="main-logo"
                    src={this.state.sticked ? logoSmall : logo}
                    alt=""
                  />
                </Link>
              </div>
              <div className="header__entry-switch">
                <div className="header_menu t-primary-14 t-weight-b">
                  <Link className="header-link" to="/about">
                    About
                  </Link>
                  <Link className="header-link" to="/faq">
                    FAQs
                  </Link>
                  <Link className="header-link" to="/contact">
                    Contact us
                  </Link>
                </div>
                <Link className="mui-button" to="/login">
                  Login
                </Link>
              </div>
            </Grid>
          </Grid>
        }
      >
        <section className="sticky-trigger" style={{ height: '100px' }} />
      </StickyHeader>
    );
  }
}

export default Header;
